const PromotingIndependenceIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M32 25.0134C30.7377 25.9169 29.3401 26.6079 27.8609 27.0599C27.067 26.1336 26.0119 25.4772 24.8384 25.1792C23.6648 24.8812 22.4293 24.9562 21.2991 25.3939C20.1689 25.8316 19.1984 26.611 18.5189 27.6266C17.8395 28.6422 17.4838 29.845 17.5 31.0724V32.4099C15.1835 32.4709 12.888 31.9496 10.8181 30.8924C8.74825 29.8353 6.96815 28.2752 5.63636 26.351C5.63636 26.351 1.6819 37.4674 13.5455 42.8175C10.8308 44.6873 6.27852 46.5461 3 46.4137C14.8636 53.1013 29.3636 46.4137 29.3636 31.0323C29.3624 30.6597 29.3271 30.2881 29.2582 29.9221C30.6035 28.5759 31.5529 26.8762 32 25.0134Z"
        stroke="#06AEB3"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M61 15.0134C59.7377 15.9169 58.3401 16.6079 56.8609 17.0599C56.067 16.1336 55.0119 15.4772 53.8384 15.1792C52.6648 14.8812 51.4293 14.9562 50.2991 15.3939C49.1689 15.8316 48.1984 16.611 47.5189 17.6266C46.8395 18.6422 46.4838 19.845 46.5 21.0724V22.4099C44.1835 22.4709 41.888 21.9496 39.8181 20.8924C37.7483 19.8353 35.9681 18.2752 34.6364 16.351C34.6364 16.351 30.6819 27.4674 42.5455 32.8175C39.8308 34.6873 35.2785 36.5461 32 36.4137C43.8636 43.1013 58.3636 36.4137 58.3636 21.0323C58.3624 20.6597 58.3271 20.2881 58.2582 19.9221C59.6035 18.5759 60.5529 16.8762 61 15.0134Z"
        stroke="#FFA473"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PromotingIndependenceIcon;
